module.exports = __webpack_public_path__ + "static/media/p2.285cf1aa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/p2.png
// module id = 956
// module chunks = 0